import rootReducer, { rootSaga } from "./stores";
import createSagaMiddleware from "redux-saga";
import { applyMiddleware, createStore } from "redux";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { composeWithDevTools } from "redux-devtools-extension";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
import HotelListContainer from "./containers/Hotel/HotelListContainer";
import LoginContainer from "./containers/Login/LoginContainer";
import DetailFormContainer from "./containers/Commons/DetailFormContainer";
import NotifyTemplateListContainer from "./containers/NotifyTemplate/NotifyTemplateListContainer";
import NotifyTemplateDetailContainer from "./containers/NotifyTemplate/NotifyTemplateDetailContainer";
import NotifyChannelListContainer from "./containers/NotifyChannel/NotifyChannelListContainer";
import NotifyChannelDetailContainer from "./containers/NotifyChannel/NotifyChannelDetailContainer";
import SpinContainer from "./containers/Commons/SpinContainer";
import DashboardMainContainer from "./containers/Dashboard/DashboardMainContainer";
import NotFound from "./components/Commons/NotFound";
import DoorlockAllListContainer from "./containers/Doorlock/DoorlockAllListContainer";
import DoorlockAllDetailContainer from "./containers/Doorlock/DoorlockAllDetailContainer";
import { QueryClientProvider, QueryClient } from "react-query";
import OauthListContainer from "./containers/Oauth/OauthListContainer";
import QrCodeViewContainer from "./containers/QrCode/QrCodeViewContainer";
import QrCodeTestViewContainer from "./containers/QrCode/QrCodeTestViewContainer";

const App = () => {
  const persistConfig = {
    key: "root",
    whitelist: [
      "header",
      "sidebar",
      "breadcrumb",
      "hotelList",
      "staffList",
      "roomList",
      "reportList",
      "notifyTemplateList",
      "hotelnotifyList",
      "floorList",
      "doorlockLogList",
      "doorlockBatteryList",
      "doorlockList",
      "buildingList",
      "bookingList",
      "doorlockAllList",
    ], //List 관련 필터는 저장
    storage,
  };

  const queryClient = new QueryClient();

  const enhancedReducer = persistReducer(persistConfig, rootReducer);
  const sagaMiddleware = createSagaMiddleware();
  const store = createStore(enhancedReducer, composeWithDevTools(applyMiddleware(sagaMiddleware)));

  sagaMiddleware.run(rootSaga);

  const persistor = persistStore(store);
  const clientId = process.env.REACT_APP_GOOGLE_API_KEY ?? "";

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <QueryClientProvider client={queryClient}>
            <BrowserRouter>
              {/* 로딩(스핀) 과 라우터 부분 시작 */}
              <SpinContainer />
              <Routes>
                <Route path="/" element={<LoginContainer />} />
                <Route path="/login" element={<LoginContainer />} />
                <Route path="/dashboard" element={<DashboardMainContainer />} />
                <Route path="/hotel" element={<HotelListContainer />} />
                <Route path="/hotel/:id">
                  <Route index element={<DetailFormContainer />} />
                  {/* <Route path="/building" element={<BuildingListContainer />} /> */}
                </Route>
                <Route path="/notify_template" element={<NotifyTemplateListContainer />} />
                <Route path="/notify_template/:id" element={<NotifyTemplateDetailContainer />} />
                <Route path="/notify_channel" element={<NotifyChannelListContainer />} />
                <Route path="/notify_channel/:id" element={<NotifyChannelDetailContainer />} />

                <Route path="/doorlock" element={<DoorlockAllListContainer />} />
                <Route path="/doorlock/:id" element={<DoorlockAllDetailContainer />} />
                <Route path="/oauth" element={<OauthListContainer />} />
                <Route path="/qrcodes/:id" element={<QrCodeViewContainer />} />
                <Route path="/qrcodes_test" element={<QrCodeTestViewContainer />} />
                <Route path="/*" element={<NotFound />} />
              </Routes>
              {/*  끝 */}
            </BrowserRouter>
          </QueryClientProvider>
        </PersistGate>
      </Provider>
    </GoogleOAuthProvider>
  );
};

export default App;
